// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3pcoT","buttonCaption":"button_buttonCaption__2NQ92","spinner":"button_spinner__3KWcX"};